// src/utils/phoneRules.ts
import type { Rule } from 'antd/es/form';
import { digitsOnly, normalizeAmPhone } from './phone';

/** Простая проверка валидности армянского номера (ровно 8 локальных цифр). */
export function isValidAmPhone(input: string): boolean {
  const d = digitsOnly(input || '');
  if (!d) return false;

  // допускаем формы: +374XXXXXXXX / 374XXXXXXXX / 0XXXXXXXX / XXXXXXXX
  if (d.startsWith('374')) return d.slice(3).length === 8;
  if (d.startsWith('0'))   return d.slice(1).length === 8;
  return d.length === 8;
}

/** Нормализация к E.164 (+374XXXXXXXX) с обязательной валидностью, иначе null. */
export function normalizeAmPhoneStrict(input: string): string | null {
  if (!isValidAmPhone(input)) return null;
  const n = normalizeAmPhone(input);
  // "+374" (4 символа) + 8 цифр = 12 символов
  return n && n.length === 12 ? n : null;
}

/**
 * Единое правило для AntD Form.
 * ВАЖНО: поле остаётся необязательным (как у вас сейчас).
 * Если оно пустое — валидатор пропускает значение.
 */
export const amPhoneRule: Rule = {
  validator: async (_rule, value: string) => {
    if (value == null || String(value).trim() === '') {
      // Пустое — валидно, так как поле у вас необязательное
      return Promise.resolve();
    }
    return isValidAmPhone(String(value))
      ? Promise.resolve()
      : Promise.reject(
          new Error('Введите корректный номер телефона (Армения): +374 XX XXX XXX')
        );
  },
};
